import { FaUser } from "react-icons/fa6";
import { IOfferedSubjectData, IQuota } from "../../types";
import { getQuotaColor } from "../../utils";
import { useTranslatedText } from "../../contexts/TranslationContext";

interface Props {
  subjectData: IOfferedSubjectData;
  qty: number;
  quota: IQuota;
  idMateria: number;
  availability: number;
  anioLectivo?: any;
}
export default function QuotaCountIcon({ subjectData, qty, idMateria, quota, availability, anioLectivo }: Props) {
  const showCupoInfo =
    process.env.REACT_APP_ENV === "Test" ||
    process.env.REACT_APP_ENV === "Localhost" ||
    process.env.REACT_APP_ENV === "Staging" ||
    process.env.REACT_APP_ENV === "Dev";

  const cupoLabel = useTranslatedText("Cupo");
  const cuotaLabel = useTranslatedText("Cuota");
  const idCursoLabel = useTranslatedText("ID curso");
  const anioLectivoLabel = useTranslatedText("Año lectivo");
  const idMateriaLabel = useTranslatedText("ID materia");
  const idCupoLabel = useTranslatedText("ID cupo");

  const tooltip =
    subjectData.reserveData.tic && subjectData.reserveData.tim && showCupoInfo
      ? `${cupoLabel}: ${subjectData.reserveData.tic} ${subjectData.reserveData.tim}   |   ${cuotaLabel}: ${qty || "-"}   |   ${idCursoLabel}:  ${subjectData.reserveData.idS}   |   ${anioLectivoLabel}: ${anioLectivo || "-"}   |   ${idMateriaLabel}:  ${idMateria}   |   ${idCupoLabel}:  ${subjectData.reserveData.idC}   |   ${anioLectivoLabel}:  ${subjectData.reserveData.aL}`
      : "";

  return (
    <>
      <FaUser
        title={tooltip}
        style={{ color: quota ? getQuotaColor(availability) : "black" }}
        className={`desktop-icon-user-quota ${showCupoInfo ? "desktop-icon-user-quota-hover" : ""}`}
      />
    </>
  );
}
